import VideoStreamContainer from "../../components/VideoStreamContainer";
import { useVideoStream } from "../../providers/videoStreams";

const VideoStreams = () => {
  const { allVideoStreams } = useVideoStream();
  return (
    <>
      <VideoStreamContainer />
    </>
  );
};

export default VideoStreams;
